import React, { memo } from "react";
import Image from "./layout/Image";

function About() {
    return (
        <section
            id="about"
            className={ `py-14 px-12` }
        >
            <div className="flex md:flex-nowrap flex-wrap flex-row-reverse gap-3">
                <div className="md:w-1/2 w-full">
                    <Image
                        alt={ `About Image` }
                        className={ `w-100 h-100 rounded-xl` }
                        src={ `https://ik.imagekit.io/omarkhaled/My_Portfolio/about-img_gCmg01H86.webp?ik-sdk-version=javascript-1.4.3&updatedAt=1647622185286` }
                    />
                </div>

                <div className="md:w-1/2 w-full">
                    <h2 className={ `text-3xl` }>About Me</h2>
                    <hr className={`border-2 border-blue-700`} />
                    <p className={ `text-lg text-gray-600 pl-3 pt-3 capitalize` }>
                        My name is Omar Khaled. <br />
                        I am an full-stack php web developer and javascript specialist.
                        Check out my Skills and see what technologies i can work by.
                        <br />
                        Feel free to take a look at my latest projects on the previous works.

                    </p>
                </div>
            </div>
        </section>
    )
}

export default memo( About )